import { put, call, takeLatest, throttle, select } from 'redux-saga/effects';
import {
  AuthActions,
  failedSignIn,
  successSignIn,
  failedVerifyOTP,
  failedVerifyMobile,
  successVerifyMobile,
  successVerifyOTP,
  verifyMobileOTPRequired,
  saveGuestUser,
  storeUser,
  resetPasswordRequest,
  resetPasswordFailed,
  resetPasswordSuccess,
  resetPasswordInitiateSuccess,
  getCountry,
  getOtpSuccess,
  getOtpFailure,
  verifyOtpRequest,
  verifyOtpFailure,
  verifyOtpSuccess,
  updateProfileSuccess,
  updateProfileFailure,
  updateProfileRequest,
  rateLimitExceeds,
} from './AuthActions';
import {
  SIGNUP_REQUEST,
  SIGNIN_REQUEST,
  OTP_VERIFICATION_REQUEST,
  MOBILE_VERIFICATION_REQUEST,
  RESET_PASSWORD_REQUEST,
  GET_COUNTRY_CODE_SUCCESS,
  GET_COUNTRY_CODE_REQUEST,
  GET_OTP_REQUEST,
  VERIFY_OTP_REQUEST,
  UPDATE_PROFILE_REQUEST,
  ALL_STATE_INFO_LOG,
} from './AuthConstants';
import {
  signUp,
  signIn,
  verifyMobile,
  verifyOTP,
  resetPassword,
  getCountryCode,
  getOtp,
  verifyOtp,
  verifyProfileEmailOtp,
  updateProfile,
  logPrint,
  getServerInfo,
} from './AuthAPI';
import {  deriveHmacKey, getSessionIdFromToken, validateAndParseResponse } from '../../utils/hmac-utils';
import {
  SignUpForm,
  SignUpData,
  UserDetails,
  MetaResult,
  SignInForm,
  MessageResult,
  MobileVerificationDetails,
  MobileVerificationResult,
  OTPVerificationDetails,
  ResetPassword,
} from './AuthModels';
import {
  ACCESS_TOKEN,
  GUEST_EMAIL,
  GUEST_MOBILE_NUMBER,
  GUEST_USER_NAME,
  USER_DETAILS,
  REFRESH_TOKEN,
  USER_ID,
  SERVERKNOWNSALT,
} from '../../constants';
import { AxiosResponse } from 'axios';
import { Store } from '../../configureStore';
import { decryptJson } from '../../utils/react-ec-utils';
import { updateUserDetails } from '../user/userAPI';
import { showErrorToast, showErrorToastDesktop } from '../../utils/toastUtils';
import { updateUserDetailsFailure, usedMobileorEmail } from '../user/userActions';
import { deleteCookie, getCookie, setCookie } from "../../../helper/cookieHelper";
import { resetSessionErrorFlag } from "../../Api";
import { askToLogin } from '../cart/cartActions';

const isAxiosStatusOnlyMessage = (value: string) =>
  /^Request failed with status code \d+$/i.test(String(value || '').trim());

const coerceBackendMessage = (...sources: any[]): string => {
  for (const source of sources) {
    const candidate =
      typeof source === 'string'
        ? source
        : source?.message ??
          source?.responseMessage ??
          source?.metaDataInfo?.responseMessage ??
          source?.error?.message ??
          source?.data?.message ??
          source?.body?.message;

    if (typeof candidate === 'string') {
      const normalizedCandidate = candidate.trim();
      if (normalizedCandidate && !isAxiosStatusOnlyMessage(normalizedCandidate)) {
        return normalizedCandidate;
      }
    }
  }

  return '';
};

const extractErrorMessage = (source: any, fallback = 'Please Try Again') =>
  coerceBackendMessage(
    source?.response?.data,
    source?.response?.data?.data,
    source?.response?.data?.body,
    source?.data,
    source?.data?.data,
    source?.body,
    source,
    fallback
  ) || fallback;

const isOtpAttemptLimitMessage = (message: string, status?: number) => {
  const normalizedMessage = String(message || '').toLowerCase();
  return (
    Number(status) === 429 ||
    normalizedMessage.includes('too many') ||
    (normalizedMessage.includes('attempt') && normalizedMessage.includes('try again later'))
  );
};
// function* signUpSaga(action: AuthActions) {
//   try {
//     const response = yield call(signUp, action.payload as SignUpData);
//     if (response.status === 200) {
//       const result = response.data as MetaResult;
//       if (result.metaDataInfo.responseCode == "ERROR") {
//         yield put(
//           failedSignUp({ message: result.metaDataInfo.responseMessage })
//         );
//       } else if (result.metaDataInfo.responseCode == "SUCCESS") {
//         yield put(
//           successSignUp({ message: result.metaDataInfo.responseMessage })
//         );
//       }
//     }
//   } catch (err) {
//     yield put(failedSignUp({ message: "Please Try Again" }));
//   }
// }

function* signInSaga(action: AuthActions) {
  try {
    const response: AxiosResponse = yield call(signIn, action.payload as SignInForm);
    const data = decryptJson(response.data.encryptedText);
    if (data.userId) {
      const result = data as UserDetails;

      // Clear Guest Details
      localStorage.removeItem(GUEST_EMAIL);
      localStorage.removeItem(GUEST_MOBILE_NUMBER);
      localStorage.removeItem(GUEST_USER_NAME);

      // Storing Auth Details
      setCookie(USER_ID, result.id)
      // localStorage.setItem(USER_ID, result.id);

      const userDetails = getCookie(USER_DETAILS);
      // console.log("userDetailsCookie 2", userDetails);
      // const userDetailsLocal = JSON.parse(localStorage.getItem(USER_DETAILS) || "{}");
      result.name && (userDetails.firstName = result.name);
      result.mobilePhone && (userDetails.mobilePhone.firstName = result.mobilePhone);

      (result.name || result.mobilePhone) && 
        // localStorage.setItem(USER_DETAILS, JSON.stringify(userDetails));
        setCookie(USER_DETAILS, userDetails,)

      // result.accessToken &&
      //   localStorage.setItem(ACCESS_TOKEN, result.accessToken);
      // result.refreshToken &&
      //   localStorage.setItem(REFRESH_TOKEN, result.refreshToken);

      result.accessToken && localStorage.setItem(ACCESS_TOKEN, result.accessToken);
      result.refreshToken && localStorage.setItem(REFRESH_TOKEN, result.refreshToken);

      // Reset session error flag on successful sign in
      resetSessionErrorFlag();

      yield put(successSignIn(result));
    } else {
      yield put(failedSignIn({ message: 'Invalid Username or Password' }));
    }
  } catch (err) {
    console.error('error in signInSaga', err);
    yield put(failedSignIn({ message: 'Failed to SignIn, Please Try Again' }));
  }
}

function* verifyMobileSaganew(action: AuthActions) {
  const mobileRequestDetails = action.payload as MobileVerificationDetails;
  try {
    const isUserSignedIn = (Store.getState().auth as any).signedIn;

    mobileRequestDetails.saveCustomerRelease = 1;
    const response: AxiosResponse = yield call(verifyMobile, mobileRequestDetails);
    if (response.status == 200) {
      const result = response.data as MetaResult;
      const guestUser = action.payload as MobileVerificationDetails;
      if (!isUserSignedIn) {
        // Store Guest User Details in Local Storage
        // Store UserID
        setCookie(USER_ID, result.metaDataInfo.responseMessage);
        // localStorage.setItem(USER_ID, result.metaDataInfo.responseMessage);
        yield put(
          storeUser({
            id: result.metaDataInfo.responseMessage,
          })
        );

        // Store Guest User
        localStorage.setItem(GUEST_USER_NAME, guestUser.fullName);
        localStorage.setItem(GUEST_MOBILE_NUMBER, guestUser.mobilePhone);
        if (guestUser.email.length > 0) {
          localStorage.setItem(GUEST_EMAIL, guestUser.email);
        }
        yield put(
          saveGuestUser({
            email: guestUser.email,
            fullName: guestUser.fullName,
            mobile: guestUser.mobilePhone,
            adultSize: 0,
            kidzSize: 0,
          })
        );
      }
      yield put(successVerifyMobile({ userID: result.metaDataInfo.responseMessage }));
    }
  } catch (err) {
    console.error('error in verifyMobileSaganew', { err });
  }
}

function* verifyMobileSaga(action: AuthActions) {
  const mobileRequestDetails = action.payload as MobileVerificationDetails;
  const countryCode = mobileRequestDetails?.mobilePhone?.includes('+91') ? 'IND' : 'US';

  mobileRequestDetails.countryCode = countryCode;

  const isUserSignedIn = (Store.getState().auth as any).signedIn;

  try {
    const response: AxiosResponse = yield call(verifyMobile, mobileRequestDetails);

    if (response.status === 200) {
      const data = decryptJson(response?.data?.encryptedText);
      const result = data as MetaResult;
      if (
        result.metaDataInfo.responseCode == 'SUCCESS' &&
        (action.payload as OTPVerificationDetails).isGuestUser
      ) {
        const guestUser = action.payload as MobileVerificationDetails;
        if (!isUserSignedIn) {
          // Store Guest User Details in Local Storage
          // Store UserID
          setCookie(USER_ID, result.metaDataInfo.responseMessage);
          // localStorage.setItem(USER_ID, result.metaDataInfo.responseMessage);
          yield put(
            storeUser({
              id: result.metaDataInfo.responseMessage,
            })
          );
          // Store Guest User
          localStorage.setItem(GUEST_USER_NAME, guestUser.fullName);
          localStorage.setItem(GUEST_MOBILE_NUMBER, guestUser.mobilePhone);
          if (guestUser.email.length > 0) {
            localStorage.setItem(GUEST_EMAIL, guestUser.email);
          }
          yield put(
            saveGuestUser({
              email: guestUser.email,
              fullName: guestUser.fullName,
              mobile: guestUser.mobilePhone,
              adultSize: 0,
              kidzSize: 0,
            })
          );
        }
        yield put(successVerifyMobile({ userID: result.metaDataInfo.responseMessage }));
      } else {
        yield put(
          verifyMobileOTPRequired({
            message: result.metaDataInfo.responseMessage,
          })
        );
      }
    } else {
      yield put(failedVerifyMobile({ message: response?.data?.message }));
    }
  } catch (err: any) {
    yield put(failedVerifyMobile({ message: 'Please Try Again' }));
  }
}

function* verifyOTPSaga(action: AuthActions) {
  const mobileRequestDetails = action.payload as OTPVerificationDetails;
  const countryCode = mobileRequestDetails?.mobilePhone?.includes('+91') ? 'IND' : 'US';

  mobileRequestDetails.countryCode = countryCode;
  try {
    const response: AxiosResponse = yield call(
      verifyOTP,
      mobileRequestDetails as OTPVerificationDetails
    ) as any;
    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText);
      const result = data as MetaResult;
      if (result.statusCodeValue !== 200) {
        yield put(failedVerifyOTP({ message: result.metaDataInfo.responseMessage }));
      } else if (result.statusCodeValue == 200) {
        // localStorage.removeItem(GUEST_EMAIL);
        localStorage.removeItem(GUEST_MOBILE_NUMBER);
        // localStorage.removeItem(GUEST_USER_NAME);

        // Storing Auth Details
        setCookie(USER_ID, result.customerId);
        // localStorage.setItem(USER_ID, result.customerId);
        setCookie(ACCESS_TOKEN, data?.access_token, data?.expires_in);

        const userDetails: any = getCookie(USER_DETAILS) || {};
        if (result.mobilePhone) {
          userDetails.mobilePhone = result.mobilePhone
          // localStorage.setItem(USER_DETAILS, userDetails);
          setCookie(USER_DETAILS, userDetails)
        }

        yield put(successVerifyOTP({ userID: result.metaDataInfo.responseMessage }));
      }
      // else if ( (action.payload as OTPVerificationDetails).isGuestUser && result.metaDataInfo.responseCode == "SUCCESS") {
      //   // Store userId in Local Storage isGuestUser
      //   localStorage.setItem(USER_ID, result.metaDataInfo.responseMessage);
      //   localStorage.setItem(GUEST_USER_NAME,(action.payload as OTPVerificationDetails).fullName);
      //   localStorage.setItem(GUEST_MOBILE_NUMBER,(action.payload as OTPVerificationDetails).mobilePhone);
      //   localStorage.setItem(GUEST_EMAIL,(action.payload as OTPVerificationDetails).email);
      //   yield put(successVerifyOTP({ userID: result.metaDataInfo.responseMessage }));
      // }
      else {
        yield put(successVerifyOTP({ userID: result.metaDataInfo.responseMessage }));
      }
    } else {
      yield put(failedVerifyOTP({ message: 'Please Try Again' }));
    }
  } catch (err) {
    yield put(failedVerifyOTP({ message: 'Please Try Again' }));
  }
}

function* resetPasswordSaga(action: AuthActions):any {
   const isMobile = window.innerWidth <= 768;
  try {
    const requestData = action.payload as ResetPassword;
let  parsedResponse;
    const response: AxiosResponse = yield call(resetPassword, requestData);
     parsedResponse = yield call(
      validateAndParseResponse,
      response.data
    );
    if(!parsedResponse?.valid)
                {
                  if (isMobile) {
                         showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                       } else {
                         showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                       }
                       return ;
                }
 
    
    if (response.status == 200) {
      // const data = decryptJson(response?.data?.encryptedText);
       const data =response?.data?.data ;
      const result = data as MetaResult;
      if (result.metaDataInfo.responseCode == 'SUCCESS') {
        if (requestData.sendOtp) {
          // Initiate Request
          yield put(resetPasswordInitiateSuccess());
        } else {
          // Update New Password
          yield put(resetPasswordSuccess());
        }
      } else {
        yield put(resetPasswordFailed(result.metaDataInfo.responseMessage));
      }
    } else {
      // const data = decryptJson(response?.data?.encryptedText);
          const data = response?.data?.data;
      yield put(resetPasswordFailed(data?.data?.message));
    }
  } catch (err) {
    yield put(resetPasswordFailed('Reset Password failed, Please try Again'));
  }
}


function* logPrintSaga(action: AuthActions) {
  try {
    const requestData = action.payload as ResetPassword;
const stateInfoStr = JSON.stringify(requestData);
    const response: AxiosResponse = yield call(logPrint, stateInfoStr);
    if (response.status == 200) {
     console.log("Logs printed successfully");
     
    } else {
    console.log("Error whilte printing logs");
    }
  } catch (err) {
 console.log("Error whilte printing logs");
  }
}


function* getCountryCodeSaga(action: AuthActions) {
  try {
    const response: AxiosResponse = yield call(getCountryCode);
    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText);
      yield put(getCountry(data));
    }
  } catch (err) {
    console.error('Error to get Country Code');
  }
}

function* getOtpSaga(action: AuthActions) {
  const isMobile = window.innerWidth <= 768;
  try {
    const response: AxiosResponse = yield call(getOtp, action.payload);
    const responseData = response?.data || {};
    const bodyHttpStatus = Number(
      responseData?.httpStatus ?? responseData?.status ?? responseData?.statusCode ?? 200
    );
    const isExplicitErrorBody =
      bodyHttpStatus >= 400 || responseData?.success === false || responseData?.error === true;

    if (response.status === 200 && !isExplicitErrorBody) {
      yield put(getOtpSuccess(response.data));
    } else if (response.status === 429 || bodyHttpStatus === 429) {
      const errorMessage = responseData?.message || 'Too many attempts, please try again later';
      if (isMobile) {
        showErrorToast(errorMessage);
      } else {
        showErrorToastDesktop(errorMessage);
      }
      yield put(rateLimitExceeds(bodyHttpStatus === 429 ? 429 : response.status));
    } else {
      const errorMessage = responseData?.message || 'Please Try Again';
      if (isMobile) {
        showErrorToast(errorMessage);
      } else {
        showErrorToastDesktop(errorMessage);
      }
      yield put(getOtpFailure(response.data));
    }
  } catch (err: any) {
    if (isMobile) {
      showErrorToast(err?.response?.data?.message);
      yield put(rateLimitExceeds(err?.response?.data?.httpStatus));
    } else {
      showErrorToastDesktop(err?.response?.data?.message);
      yield put(rateLimitExceeds(err?.response?.data?.httpStatus));
    }
    yield put(getOtpFailure(err?.response?.data || err));
  }
}

function* verifyOtpSaga(action: AuthActions) {
  const isMobile = window.innerWidth <= 768;
try {
    // Sent as a header so the backend can report the login to the fraud assessment
    // service - the request body itself is encrypted.
    const locationId: string = yield select(
      (state: any) => state.restaurant?.currentRestaurantDetail?.id || ''
    );
    const response: AxiosResponse = yield call(verifyOtp, action?.payload, locationId);
    const decryptedResponse = decryptJson(response?.data?.encryptedText);
    const customerDetails = decryptedResponse?.body?.customerDetails;
    const requestPayload = action?.payload as any;
    const normalizedRequestEmail = String(requestPayload?.email || "").trim().toLowerCase();
    const normalizedResponseEmail = String(customerDetails?.email || "").trim().toLowerCase();
    const normalizedRequestMobile = String(requestPayload?.mobilePhone || "").replace(/\D/g, "");
    const normalizedResponseMobile = String(customerDetails?.mobilePhone || "").replace(/\D/g, "");
    const isEmailFlow = Boolean(requestPayload?.sendOtpViaEmail);
    const isIdentityMatched = isEmailFlow
      ? normalizedRequestEmail !== "" && normalizedRequestEmail === normalizedResponseEmail
      : normalizedRequestMobile !== "" &&
        normalizedResponseMobile !== "" &&
        (
          normalizedRequestMobile === normalizedResponseMobile ||
          normalizedRequestMobile.endsWith(normalizedResponseMobile) ||
          normalizedResponseMobile.endsWith(normalizedRequestMobile)
        );
    const isValidOtpVerification =
      response?.status === 200 &&
      Boolean(customerDetails?.customerId) &&
      Boolean(customerDetails?.access_token) &&
      isIdentityMatched;

    if (isValidOtpVerification) {
      // Reset session error flag on successful OTP verification
      resetSessionErrorFlag();

      yield put(verifyOtpSuccess(decryptedResponse?.body?.customerDetails));
      localStorage.removeItem(GUEST_EMAIL);
      localStorage.removeItem(GUEST_MOBILE_NUMBER);
      localStorage.removeItem(GUEST_USER_NAME);
      setCookie(ACCESS_TOKEN, decryptedResponse?.body?.customerDetails?.access_token, decryptedResponse?.body?.customerDetails?.expires_in);
      yield put(askToLogin(false));
      // Storing Auth Details
      decryptedResponse?.body?.customerDetails?.customerId && setCookie(USER_ID, decryptedResponse?.body?.customerDetails?.customerId);
      decryptedResponse?.body?.customerDetails?.customerId && setCookie(USER_DETAILS, decryptedResponse?.body?.customerDetails);

      // HMAC Security: extract sessionId → call /info → derive key in memory
      try {
         const accessToken = customerDetails?.access_token;

   const infoResponse: AxiosResponse = yield call(getServerInfo);
   const serverKnownSalt = infoResponse?.data?.value;
   setCookie(SERVERKNOWNSALT,serverKnownSalt)
   
   
   const sessionId = getSessionIdFromToken(accessToken);
  if (accessToken && serverKnownSalt) {
    yield call(deriveHmacKey, accessToken, serverKnownSalt,sessionId);
  }
      } catch {
        // Non-blocking: HMAC setup failure should not block login
      }
    } else {
      deleteCookie(USER_ID);
      deleteCookie(USER_DETAILS);
      deleteCookie(ACCESS_TOKEN);
         deleteCookie(SERVERKNOWNSALT);
      yield put(verifyOtpFailure(response?.data));
    }
  } catch (err: any) {
     if (isMobile) {
        showErrorToast(err?.response?.data?.message);
      } else {
        showErrorToastDesktop(err?.response?.data?.message);
      }
    yield put(verifyOtpFailure(err));
  }
}

function* UpdateProfileSaga(action: AuthActions): any {
  const isMobile = window.innerWidth <= 768;
  const requestPayload: any = action?.payload || {};
  const isEmailOtpVerificationFlow = Boolean(requestPayload?.otp);
  let parsedResponse: any;

  try {
    if (isEmailOtpVerificationFlow) {
      const response: AxiosResponse = yield call(verifyProfileEmailOtp, requestPayload);
      const rawResponse = response?.data || {};

      try {
        parsedResponse = yield call(validateAndParseResponse, rawResponse);
      } catch {
        parsedResponse = null;
      }

      let resolvedResponse = parsedResponse?.valid ? parsedResponse?.data : rawResponse;
      if (resolvedResponse?.encryptedText) {
        try {
          resolvedResponse = decryptJson(resolvedResponse.encryptedText);
        } catch {}
      }

      const responseBody = resolvedResponse?.body || resolvedResponse?.data || resolvedResponse;
      const customerDetails =
        responseBody?.customerDetails || resolvedResponse?.customerDetails || responseBody;
      const normalizedRequestEmail = String(requestPayload?.email || '').trim().toLowerCase();
      const normalizedResponseEmail = String(customerDetails?.email || '').trim().toLowerCase();
      const normalizedRequestMobile = String(requestPayload?.mobilePhone || '').replace(/\D/g, '');
      const normalizedResponseMobile = String(customerDetails?.mobilePhone || '').replace(/\D/g, '');
      const isMobileMatched =
        !normalizedRequestMobile ||
        normalizedRequestMobile === normalizedResponseMobile ||
        normalizedRequestMobile.endsWith(normalizedResponseMobile) ||
        normalizedResponseMobile.endsWith(normalizedRequestMobile);
      const isEmailMatched =
        !normalizedRequestEmail || normalizedRequestEmail === normalizedResponseEmail;
      const responseHttpStatus = Number(
        responseBody?.httpStatus ?? resolvedResponse?.httpStatus ?? rawResponse?.httpStatus ?? response?.status
      );
      const isValidEmailOtpUpdate =
        responseHttpStatus === 200 &&
        Boolean(customerDetails?.customerId) &&
        isMobileMatched &&
        isEmailMatched;

      if (isValidEmailOtpUpdate) {
        yield put(updateProfileSuccess(responseBody));

        localStorage.removeItem(GUEST_EMAIL);
        localStorage.removeItem(GUEST_MOBILE_NUMBER);
        localStorage.removeItem(GUEST_USER_NAME);
        customerDetails?.customerId && setCookie(USER_ID, customerDetails?.customerId);
        customerDetails && setCookie(USER_DETAILS, customerDetails);

        if (customerDetails?.access_token) {
          setCookie(ACCESS_TOKEN, customerDetails?.access_token, customerDetails?.expires_in);
          try {
            const accessToken = customerDetails?.access_token;
            const infoResponse: AxiosResponse = yield call(getServerInfo);
            const serverKnownSalt = infoResponse?.data?.value;
            setCookie(SERVERKNOWNSALT, serverKnownSalt);
            const sessionId = getSessionIdFromToken(accessToken);
            if (accessToken && serverKnownSalt) {
              yield call(deriveHmacKey, accessToken, serverKnownSalt, sessionId);
            }
          } catch {}
        }
      } else {
        const errorMessage = extractErrorMessage(
          { data: responseBody, body: resolvedResponse, response: { data: rawResponse } },
          'Please enter valid otp'
        );
        if (isOtpAttemptLimitMessage(errorMessage, responseHttpStatus)) {
          if (isMobile) {
            showErrorToast(errorMessage);
          } else {
            showErrorToastDesktop(errorMessage);
          }
        }
        yield put(updateProfileFailure(errorMessage));
      }
      return;
    }

    const response: AxiosResponse = yield call(updateUserDetails, requestPayload);

    parsedResponse = yield call(validateAndParseResponse, response.data);

    if (!parsedResponse?.valid) {
      if (isMobile) {
        showErrorToast(parsedResponse?.message || 'Failed to update profile, Please try Again');
      } else {
        showErrorToastDesktop(parsedResponse?.message || 'Failed to update profile, Please try Again');
      }
      return;
    }

    const decryptedResponse = response?.data.data;
    const customerDetails = decryptedResponse?.customerDetails;
    const normalizedRequestEmail = String(requestPayload?.email || '').trim().toLowerCase();
    const normalizedResponseEmail = String(customerDetails?.email || '').trim().toLowerCase();
    const normalizedRequestMobile = String(requestPayload?.mobilePhone || '').replace(/\D/g, '');
    const normalizedResponseMobile = String(customerDetails?.mobilePhone || '').replace(/\D/g, '');

    const isMobileMatched =
      !normalizedRequestMobile ||
      normalizedRequestMobile === normalizedResponseMobile ||
      normalizedRequestMobile.endsWith(normalizedResponseMobile) ||
      normalizedResponseMobile.endsWith(normalizedRequestMobile);
    const isEmailMatched = !normalizedRequestEmail || normalizedRequestEmail === normalizedResponseEmail;
    const responseHttpStatus =
      decryptedResponse?.httpStatus !== undefined ? decryptedResponse?.httpStatus : response?.status;
    const isValidUpdateResponse =
      responseHttpStatus === 200 &&
      Boolean(customerDetails?.customerId) &&
      isMobileMatched &&
      isEmailMatched;

    if (isValidUpdateResponse) {
      yield put(updateProfileSuccess(decryptedResponse));

      localStorage.removeItem(GUEST_EMAIL);
      localStorage.removeItem(GUEST_MOBILE_NUMBER);
      localStorage.removeItem(GUEST_USER_NAME);
      deleteCookie(USER_ID);
      deleteCookie(USER_DETAILS);
      decryptedResponse?.customerDetails &&
        decryptedResponse?.customerDetails?.customerId &&
        setCookie(USER_ID, decryptedResponse?.customerDetails?.customerId);
      decryptedResponse?.customerDetails && setCookie(USER_DETAILS, decryptedResponse?.customerDetails);
    } else {
      const decryptedMessage = String(decryptedResponse?.message || response?.data?.message || '');
      const backendMessage = decryptedMessage || response?.data?.message || '';
      const lowerBackendMessage = String(backendMessage).toLowerCase();
      if (lowerBackendMessage.includes('linked')) {
        if (lowerBackendMessage.includes('number is linked')) {
          yield put(usedMobileorEmail(action.payload.mobilePhone));
        } else {
          yield put(usedMobileorEmail(action.payload.email));
        }
      }

      const errorMessage = backendMessage;
      if (isMobile) {
        showErrorToast(errorMessage);
      } else {
        showErrorToastDesktop(errorMessage);
      }
      yield put(updateProfileFailure(errorMessage));
    }
  } catch (err: any) {
    const errorMessage = extractErrorMessage(
      err,
      isEmailOtpVerificationFlow ? 'Please enter valid otp' : 'Please Try Again'
    );
    if (!isEmailOtpVerificationFlow && String(errorMessage).toLowerCase().includes('linked')) {
      if (String(errorMessage).toLowerCase().includes('number is linked')) {
        yield put(usedMobileorEmail(action.payload.mobilePhone));
      } else {
        yield put(usedMobileorEmail(action.payload.email));
      }
    }
    if (isEmailOtpVerificationFlow) {
      const errorStatus = Number(err?.response?.status || err?.response?.data?.httpStatus || 0);
      if (isOtpAttemptLimitMessage(errorMessage, errorStatus)) {
        if (isMobile) {
          showErrorToast(errorMessage);
        } else {
          showErrorToastDesktop(errorMessage);
        }
      }
    }
    yield put(updateProfileFailure(errorMessage));
  }
}
export default function* authSaga() {
  // yield takeLatest(SIGNUP_REQUEST, signUpSaga);
  yield takeLatest(GET_OTP_REQUEST, getOtpSaga);
  yield takeLatest(VERIFY_OTP_REQUEST, verifyOtpSaga);
  yield throttle(5000, SIGNIN_REQUEST, signInSaga);
  yield throttle(5000, OTP_VERIFICATION_REQUEST, verifyOTPSaga);
  yield throttle(5000, MOBILE_VERIFICATION_REQUEST, verifyMobileSaga);
  yield throttle(5000, RESET_PASSWORD_REQUEST, resetPasswordSaga);
  yield throttle(5000, GET_COUNTRY_CODE_REQUEST, getCountryCodeSaga);
  yield throttle(5000, UPDATE_PROFILE_REQUEST, UpdateProfileSaga);
    yield throttle(5000, ALL_STATE_INFO_LOG, logPrintSaga);

}
